import { render, staticRenderFns } from "./Verzeichnis_der_Mitglieder.vue?vue&type=template&id=3c0c7581&scoped=true&"
import script from "./Verzeichnis_der_Mitglieder.vue?vue&type=script&lang=js&"
export * from "./Verzeichnis_der_Mitglieder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0c7581",
  null
  
)

export default component.exports